<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{ $t('Technicians') }}</h1>
          <h2 class="page-subtitle">{{ $t('Total') }} : {{ totalCount }}</h2>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn">
          <plus-icon size="18" class="mr-1"/>
          {{ $t('Add') }} {{ $t('technician') }}
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
            ref="B122TableTechnician"
            identifier="B122TableTechnician"
            init-b122-table-url="/technician/initB122Table"
            get-b122-table-results-url="/technician/getB122TableResults"
            :fields="tableFields"
            @setTotalCount="setTotalCount"
            @clickOnShowBtn="clickOnShowBtn"
            @clickOnEditBtn="clickOnEditBtn"
            @clickOnDeleteBtn="clickOnDeleteBtn"
        >

          <!-- Exemple surchage cellule (ici actions)
          <template #cell(actions)="row">
              <strong>SURCHARGE ACTIONS</strong>
              <button @click="exempleSurchageAction(row)">exempleSurchageAction</button>
          </template>
          -->

        </b122-table>
      </b-card>
    </b-container>
    <Technician-delete-modal :selectedTechnician="ui.selectedTechnician" @didDeleteTechnician="didDeleteTechnician()"></Technician-delete-modal>
  </div>
</template>

<script>

import B122Table from "../../components/b122/B122Table";
import TechnicianDeleteModal from "./TechnicianDeleteModal";
import {dateUtils} from "../../mixins/utils";
export default {

  name: 'TechnicianIndex',

  mixins: [dateUtils],

  components: {
    B122Table,
    TechnicianDeleteModal
  },

  data() {
    return {

      totalCount: 0,

      tableFields: [
        {
          label: "",
          key: "show",
          sortable: false
        },
        {
          label: this.$i18n.t('technician.LastName'),
          key: "name",
          sortKey:"user.firstName",
          sortable: true
        },
        {
          label: this.$i18n.t('technician.Email'),
          key: "username",
          sortKey:"user.username",
          sortable: true
        },
        {
          label: this.$i18n.t('technician.NextInterventionDate'),
          key: "nextIntervention.estimatedStartDate",
          sortable: false,
          sortKey:"join itv.estimatedStartDate",
          formatter: function (value) {
            return value? dateUtils.methods.formatDateSimple(value) : ""
          }
        },
        {
          label: this.$i18n.t('client.next.intervention'),
          key: "nextIntervention.name",
          sortable: false,
          sortKey:"join itv.client.firstName"
        },
        {
          label: "",
          key: "actions"
        }
      ],
      ui: {
        selectedTechnician: null
      }
    }
  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'TechnicianCreate'
      })
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'TechnicianShow',
        params: {
          technicianId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'TechnicianEdit',
        params: {
          technicianId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedTechnician = row.item
      this.$bvModal.show('technician-delete-modal')
    },

    didDeleteTechnician() {
      this.ui.selectedTechnician = null;
      this.$refs.B122TableTechnician.refreshTable()
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/technician/TechnicianIndex.vue